import React from 'react';

import '../css/carousel-indicator.less';

export default (props) => {
    let { getSlideCount, slideCount, customSlideCount, currentSlide, goToSlide } = props;

    let numSlides = typeof customSlideCount === 'number'
                    ? customSlideCount
                    : typeof getSlideCount === 'function'
                    ? getSlideCount(props)
                    : slideCount;

    return (
        <div className='carousel-indicator'>

            { numSlides > 0 && (
                [...Array(numSlides)].map((_,i) => {
                    const selected = currentSlide < numSlides-1 ? i === currentSlide : i === numSlides-1;
                    let classNames = `${selected ? ' selected' : ''}`
                    return (
                    <div className={`carousel-dot-wrapper${classNames}`} key={i} onClick={()=> goToSlide(i)}>
                        <div className={`carousel-dot${classNames}`}></div>
                    </div>
                    );
                })
                )
            }
            
        </div>
    );
}